import './abmeldung-durch-einrichtung.js';
import './abmeldung.js';
import './bestaetigung-workshop-registrierung.js';
import './erinnerung-appointment.js';
import './erinnerung.js';
import './free-form.js';
import './lecturer-added-to-product.js';
import './lecturer-registration.js';
import './meeting-infos.js';
import './nachrueckplatz-erhalten.js';
import './nachrueckplatz-verfuegbar.js';
import './new-workshop-document.js';
import './newsletter-opt-in.js';
import './newsletter.js';
import './nutzer-sperrung-aufgehoben.js';
import './nutzer-sperrung.js';
import './nutzer-teilnahme-aufgehoben.js';
import './nutzer-teilnahme.js';
import './otp.js';
import './product-cancled.js';
import './product-decancled.js';
import './product-loeschung.js';
import './veranstaltungseintragung-durch-admin.js';
import './warteliste-vorrueck.js';
import './workshop-changed.js';
